// Home Country Ties
export const immediateFamilyMembersOptions = [
  { value: "parents", label: "Parents" },
  { value: "siblings", label: "Siblings" },
  { value: "spouse", label: "Spouse/Partner" },
  { value: "children", label: "Children" },
];

export const dependentTypesOptions = [
  { value: "financial", label: "Financial support" },
  { value: "care", label: "Care responsibilities" },
];

export const dependentRelationshipOptions = [
  { value: "spouse", label: "Spouse" },
  { value: "de_facto_partner", label: "De Facto Partner" },
  { value: "child", label: "Child" },
  { value: "parent", label: "Parent" },
];

export const communityOrganizationTypesOptions = [
  { value: "religious", label: "Religious organization" },
  { value: "professional", label: "Professional association" },
  { value: "sports_cultural", label: "Sports/cultural club" },
  { value: "volunteer", label: "Volunteer organization" },
  { value: "other", label: "Other" },
];

export const communityIntegrationOptions = [
  { value: "deeply_integrated", label: "Deeply integrated" },
  { value: "moderately_integrated", label: "Moderately integrated" },
  { value: "minimally_integrated", label: "Minimally integrated" },
  { value: "not_integrated", label: "Not integrated" },
];

export const employmentTypeOptions = [
  { value: "full_time", label: "Full-time" },
  { value: "part_time", label: "Part-time" },
  { value: "self_employed", label: "Self-employed" },
  { value: "contract", label: "Contract" },
];

export const mainIncomeSourceOptions = [
  { value: "family_support", label: "Family support" },
  { value: "savings", label: "Savings" },
  { value: "business_income", label: "Business income" },
  { value: "Government_support", label: "Government support" },
  { value: "other", label: "Other" },
];

export const propertyTypesOptions = [
  { value: "residential", label: "Residential" },
  { value: "commercial", label: "Commercial" },
  { value: "agricultural", label: "Agricultural land" },
];

export const businessRoleOptions = [
  { value: "sole_owner", label: "Sole owner" },
  { value: "partner", label: "Partner" },
  { value: "shareholder", label: "Shareholder" },
  { value: "manager", label: "Manager" },
];

// Course & Career
export const gapActivityOptions = [
  { value: "education", label: "Further education" },
  { value: "family", label: "Family responsibilities" },
  { value: "health", label: "Health issues" },
  { value: "job_search", label: "Job searching" },
  { value: "travel", label: "Travel" },
  { value: "other", label: "Other" },
];

export const whyStudyAbroadOptions = [
  { value: "better_quality", label: "Significantly better quality" },
  {
    value: "specific_specialization",
    label: "Specific specialization unavailable",
  },
  {
    value: "international_recognition",
    label: "International credential recognition",
  },
  { value: "english_language", label: "English language instruction" },
  { value: "research_facilities", label: "Superior research facilities" },
  { value: "industry_connections", label: "Better industry connections" },
  { value: "other", label: "Other" },
];

export const researchActivitiesOptions = [
  { value: "compared_curricula", label: "Compared curricula" },
  {
    value: "compared_fees",
    label: "Compared fees and scholarships",
  },
  {
    value: "reviewed_outcomes",
    label: "Reviewed graduate outcomes",
  },
  {
    value: "attended_sessions",
    label: "Attended information sessions",
  },
  {
    value: "contacted_alumni",
    label: "Contacted current students/alumni",
  },
];

export const postStudyLocationOptions = [
  { value: "definitely_home", label: "Definitely home country" },
  { value: "likely_home", label: "Likely home country" },
  { value: "undecided", label: "Undecided" },
  { value: "third_country", label: "Third country" },
  { value: "hope_stay", label: "Hope to stay in host" },
];

export const demandLevelOptions = [
  { value: "high_demand", label: "High demand" },
  { value: "moderate_demand", label: "Moderate demand" },
  { value: "low_demand", label: "Low demand" },
  { value: "emerging_field", label: "Emerging field" },
  { value: "uncertain", label: "Uncertain" },
];

export const incomeChangeOptions = [
  { value: "significant_increase", label: "Significant increase" },
  { value: "moderate_increase", label: "Moderate increase" },
  { value: "modest_increase", label: "Modest increase" },
  { value: "similar", label: "Similar" },
  { value: "not_for_income", label: "Not primarily for income" },
];

export const qualificationUseOptions = [
  { value: "employment", label: "Employment in same/related field" },
  { value: "advancement", label: "Career advancement/promotion" },
  { value: "change", label: "Career change to new field" },
  { value: "Start_business", label: "Start own business" },
  {
    value: "professional_licensing",
    label: "Professional licensing requirement",
  },
  { value: "further_study", label: "Further academic study" },
  { value: "other", label: "Other" },
];

// Immigration & Intent
export const furtherStudyPlansOptions = [
  { value: "higher_degree", label: "Higher degree same field" },
  { value: "different_field", label: "Different field" },
  { value: "short_courses", label: "Short courses" },
  { value: "undecided", label: "Undecided" },
];

export const postStudyWorkDurationOptions = [
  { value: "less_than_6_months", label: "Less than 6 months" },
  { value: "6_12_months", label: "6-12 months" },
  { value: "1_2_years", label: "1-2 years" },
  { value: "2+_years", label: "2+ years" },
  { value: "undecided", label: "Undecided" },
];

export const permanentResidenceInterestOptions = [
  { value: "primary_goal", label: "Primary goal" },
  { value: "secondary_option", label: "Secondary option" },
  { value: "open_possibility", label: "Open to possibility" },
  { value: "depends_outcomes", label: "Depends on outcomes" },
];

export const returnTimeframeOptions = [
  { value: "immediately_after", label: "Immediately after studies" },
  { value: "brief_work_experience", label: "After brief work experience" },
  { value: "after_1_3_years", label: "After 1-3 years" },
  { value: "flexible", label: "Flexible " },
  { value: "uncertain", label: "Uncertain" },
];

export const previousProgramNonCompletionReasonOptions = [
  { value: "financial", label: "Financial" },
  { value: "academic", label: "Academic" },
  { value: "personal_health", label: "Personal/health" },
  { value: "visa_issues", label: "Visa issues" },
  { value: "changed_course", label: "Changed course" },
  { value: "other", label: "Other" },
];

// Financial & Preparation
export const primaryFundingOptions = [
  { value: "personal_savings", label: "Personal savings" },
  { value: "family_support", label: "Family support" },
  { value: "scholarship_grants", label: "Scholarship/grant" },
  { value: "government_loan", label: "Government loan" },
  { value: "bank loan", label: "Bank loan" },
  { value: "employer_sponsorship", label: "Employer sponsorship" },
  { value: "other", label: "Other" },
];

export const sponsorRelationshipOptions = [
  { value: "parent", label: "Parent" },
  { value: "spouse", label: "Spouse" },
  { value: "sibling ", label: "Sibling" },
  { value: "other_family", label: "Other family" },
  { value: "organization", label: "Organization" },
  { value: "government", label: "Government" },
];

export const sponsorVisaStatusOptions = [
  { value: "citizen", label: "Australian Citizen" },
  { value: "permanent_resident", label: "Permanent Resident" },
  { value: "working_visa", label: "Working Visa" },
  { value: "temporary_visa", label: "Temporary Visa" },
  { value: "no_visa", label: "No Australian Visa (Outside Australia)" },
];

export const financialObligationTypesOptions = [
  { value: "family_support", label: "Family support" },
  { value: "loan_repayments", label: "Loan repayments" },
  {
    value: "business_commitments",
    label: "Business commitments",
  },
  { value: "property_expenses", label: "Property expenses" },
  { value: "other", label: "Other" },
];

export const incomeGeneratingAssetTypesOptions = [
  { value: "rental_income", label: "Rental property income" },
  { value: "business_income", label: "Business income" },
  { value: "investment_returns", label: "Investment returns" },
  { value: "other", label: "Other" },
];

export const researchConductedFullOptions = [
  { value: "course_curriculum", label: "Reviewed course curriculum in detail" },
  { value: "students_alumni", label: "Contacted current students/alumni" },
  {
    value: "information_sessions",
    label: "Attended provider information sessions",
  },
  {
    value: "faculty_research",
    label: "Researched faculty and research groups",
  },
  {
    value: "employment_outcomes",
    label: "Investigated graduate employment outcomes",
  },
  { value: "living_costs", label: "Researched living costs" },
  { value: "accommodation_options", label: "Researched accommodation options" },
  { value: "visited_campus ", label: "Visited campus" },
  { value: "limited_research", label: "Limited research" },
];

export const accommodationTypeOptions = [
  { value: "on_campus", label: "On-campus" },
  { value: "Off_campus_rental", label: "Off-campus rental" },
  { value: "homestay", label: "Homestay" },
  { value: "family_friends", label: "With family/friends" },
  { value: "not_arranged", label: "Not yet arranged" },
];

export const preparationActivitiesOptions = [
  { value: "preparation", label: "Language courses/test preparation" },
  { value: "online_courses", label: "Online courses in relevant subject" },
  { value: "reading", label: "Reading academic papers/books" },
  { value: "skills_development", label: "Skills development" },
  { value: "industry_certifications", label: "Industry certifications" },
  { value: "work_experience", label: "Work experience" },
  { value: "volunteer_work", label: "Volunteer work" },
  { value: "limited_preparation", label: "Limited preparation" },
];

export const understandingLevelOptions = [
  { value: "poor", label: "Poor" },
  { value: "fair", label: "Fair" },
  { value: "good", label: "Good" },
  { value: "very_good", label: "Very good" },
  { value: "excellent", label: "Excellent" },
];

export const healthInsuranceProviderOptions = [
  { value: "ahm", label: "Australian Health Management" },
  { value: "bupa", label: "BUPA Australia" },
  { value: "medibank", label: "Medibank Private" },
  { value: "allianz", label: "Allianz Global Assistance (Lysaght Peoplecare)" },
  { value: "nib", label: "nib OSHC" },
  { value: "other", label: "Other Provider" },
];

// Section I: Declaration Options
export const getGsDeclarationOptions = (
  destinationCountry: string = "Australia"
) => [
  {
    value: "personallyWritten",
    label:
      "I have personally written the answers provided in this assessment and confirm they are a true and accurate statement of my intentions.",
  },
  {
    value: "genuineStudent",
    label: `I understand what it means to be a genuine student for the purposes of studying in ${destinationCountry}.`,
  },
  {
    value: "visaConditions",
    label:
      "I have read, I understand, and I commit to complying with all student visa conditions, including (but not limited to) maintaining enrolment, satisfactory attendance, and course progress.",
  },
  {
    value: "notifyChanges",
    label:
      "I commit to notifying the Department of Home Affairs of any changes to my circumstances (e.g., change of address, provider, or course) as required by my visa conditions.",
  },
  {
    value: "migrationPathways",
    label: `I understand that while post-study pathways to permanent migration are available, only a limited number of graduates will be eligible. I understand that if I am not eligible to remain lawfully in ${destinationCountry} after my studies, I must depart the country.`,
  },
  {
    value: "genuineDocuments",
    label:
      "I confirm that the documents I have attached are genuine and have not been altered or fabricated. I understand that providing false or misleading information or documents is a serious offence and will result in visa refusal or cancellation.",
  },
  {
    value: "finalConfirmationAndDigitalSignature",
    label:
      "I confirm that I have read and understood all the above declarations and agree to comply with all requirements.",
  },
];
